import React, {useContext, useState} from 'react';

import {ContextAuth} from '../../../../common/context/context-auth';

import {useHttpClient} from '../../../../common/hook/http';
import {useFrom} from '../../../../common/hook/form';
import {useMobileDatePicker} from '../../../../common/hook/mobile-date-picker';
import {useToast} from '../../../../common/hook/toast';

import {validatorEmail, validatorLength, validatorNationalCode, validatorNotEmpty, validatorNotRequired} from '../../../../common/util/validators';

import showValidators from '../../../../common/util/show-validators';
import setNativeValue from '../../../../common/util/set-native-value';

import FormElement from '../../../../common/component/FormElement/FormElement';

import * as IconFi from "react-icons/fi";

import {Row, Col, Form, Button, Spinner} from 'react-bootstrap';

import './Profile.scss'

const Profile = () => {
    const auth = useContext(ContextAuth)
    const {callAPI} = useHttpClient();
    const {callMobileDatePicker} = useMobileDatePicker();
    const {callToast} = useToast()

    // ----------------------------------------------------------------------------------------------------- submit form

    const [spinnerShow, setSpinnerShow] = useState(false)

    const [formState, inputHandler] = useFrom({
        formProfileGender: {
            value: '',
            isValid: false
        },
        formProfileName: {
            value: '',
            isValid: false
        },
        formProfileLast_name: {
            value: '',
            isValid: false
        },
        formProfileNational_code: {
            value: '',
            isValid: false
        },
        formProfileEmail: {
            value: '',
            isValid: true
        },
        formProfileBirthDate: {
            value: '',
            isValid: true
        },
        formProfileMarriageDate: {
            value: '',
            isValid: true
        },
        formProfileSheba: {
            value: '',
            isValid: true
        },
        formProfileAddress: {
            value: '',
            isValid: true
        }
    }, false);

    const formSubmitHandler = async event => {

        event.preventDefault();

        if (formState.isValid) {

            setSpinnerShow(true);

            const values = {}

            for (const item in formState.inputs) {
                let tempKey = item.split('formProfile')[1];
                tempKey = tempKey.charAt(0).toLowerCase() + tempKey.slice(1);
                values[tempKey] = formState.inputs[item].value
            }

            const formData = new FormData();

            for (const name in values) {

                let hasFile = ['profile']

                if (hasFile.includes(name)) formData.append(name, document.querySelector('#pageAccountProfile form [name=' + name + ']').files[0])
                else formData.append(name, values[name])

            }

            try {
                const responseData = await callAPI(
                    'user/updateprofile',
                    'POST',
                    formData,
                    {'Content-Type': 'multipart/form-data'}
                )

                callToast('secondary', null, null, 'ثبت اطلاعات با موفقیت انجام شد');

                setSpinnerShow(false);

                auth.editUser(responseData.result);

            } catch (err) {
                setSpinnerShow(false);
            }

        } else showValidators(formState.inputs)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const mobileDatePickerHandler = event => {
        let max = new Date();
        max.setDate(max.getDate());
        callMobileDatePicker(event.target.id, event.target.value, null, max)
    }

    const resetMarriageDateHandler = () => {

        setNativeValue('formProfileMarriageDate', '')

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageAccountProfile" className="has-page-footer">
            <Form id="formProfile" onSubmit={formSubmitHandler} autoComplete="off">
                <Row className="gx-3">
                    <Col xs={12} className="pb-3">
                        <figure className="ratio ratio-1x1 bg-elevate-1 rounded-square" style={{backgroundImage: 'url()'}}>
                            <div className="d-flex align-items-end justify-content-end">
                                <Button variant="link" className="rounded-square bg-elevate-6 me-n1 mb-n1 text-accent btn-icon"><IconFi.FiCamera size={24} className="sw-1"/></Button>
                            </div>
                        </figure>
                    </Col>
                    <Col xs={12}>
                        <FormElement component="RADIO_GROUP" id="formProfileGender" name="gender" radioGroup={[{value: 2, label: 'خانم'}, {value: 1, label: 'آقا'}]}
                                     labelGroup={<>جنسیت <span className="lh-0 font-en">*</span></>} inline inlineLabel validators={[validatorNotEmpty()]} textInvalid="جنسیت را مشخص نمایید"
                                     onInput={inputHandler} editValue={auth.user.gender && Number(auth.user.gender)}
                        />
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" type="text" id="formProfileName"
                                     name="name"
                                     label={<>نام <span className="lh-0 font-en">*</span></>}
                                     validators={[validatorNotEmpty()]}
                                     textInvalid="نام را وارد نمایید"
                                     onInput={inputHandler}
                                     editValue={auth.user.name && auth.user.name}
                        />
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" type="text" id="formProfileLast_name"
                                     name="last_name"
                                     label={<>نام خانوادگی <span className="lh-0 font-en">*</span></>}
                                     validators={[validatorNotEmpty()]}
                                     textInvalid="نام خانوادگی را وارد نمایید"
                                     onInput={inputHandler}
                                     editValue={auth.user.last_name && auth.user.last_name}
                        />
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" type="text" id="formProfileNational_code"
                                     name="national_code"
                                     className="ltr text-left ls-1 font-fa"
                                     label={<>کد ملی <span className="lh-0 font-en">*</span></>}
                                     validators={[validatorNationalCode()]}
                                     textInvalid="کد ملی را وارد نمایید"
                                     onInput={inputHandler}
                                     maxLength="10"
                                     editValue={auth.user.national_code && auth.user.national_code}
                                     digit inputMode="numeric"/>
                    </Col>
                    <Col md={6}/>
                    <Col md={6}>
                        <Form.Group controlId="formProfileMobile" className="mb-3">
                            <Form.Label>شماره تلفن همراه (نام کاربری)</Form.Label>
                            <Form.Control value={`0${auth.user.mobile}`} className="ltr text-left ls-1 font-fa" disabled/>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" type="text" id="formProfileEmail"
                                     name="email"
                                     label="آدرس پست الکترونیک"
                                     validators={[validatorEmail(), validatorNotRequired()]}
                                     textInvalid="آدرس پست الکترونیک را وارد نمایید"
                                     onInput={inputHandler}
                                     editValue={auth.user.email && auth.user.email}
                                     readonly
                                     className="ltr text-left" inputMode="email"/>
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" id="formProfileBirthDate" name="birthDate" label="تاریخ تولد" className="text-left ltr ls-1"
                                     editValue={auth.user.birthDate && auth.user.birthDate} onClick={mobileDatePickerHandler} readOnly onInput={inputHandler}/>
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" id="formProfileMarriageDate" name="marriageDate" label="تاریخ ازدواج" className="text-left ltr ls-1"
                                     editValue={auth.user.marriageDate && auth.user.marriageDate} onClick={mobileDatePickerHandler} readOnly onInput={inputHandler}
                                     append={formState.inputs.formProfileMarriageDate.value && <Button variant="link" className="border px-2" onClick={resetMarriageDateHandler}><IconFi.FiTrash size={24} className="sw-1"/></Button>}/>
                    </Col>
                    <Col md={6}>
                        <FormElement component="INPUT" type="text" id="formProfileSheba"
                                     name="sheba"
                                     label="شبا"
                                     validators={[validatorLength([26, 26]), validatorNotRequired()]}
                                     maxLength="26"
                                     textInvalid="شبا را وارد نمایید"
                                     onInput={inputHandler}
                                     editValue={auth.user.sheba && auth.user.sheba}
                                     className="ltr text-left"/>
                    </Col>
                    <Col xs={12}>
                        <FormElement component="TEXTAREA" id="formProfileAddress" name="address" label="آدرس" rows={2} onInput={inputHandler}/>
                    </Col>
                    <Col xs={12} className="py-2 py-md-0 mt-md-0 d-grid d-md-block page-footer">
                        <Button type="submit" className="m-1 m-md-0 btn-loading" disabled={spinnerShow}>
                            <Spinner as="i" animation="border" size="sm" className={spinnerShow && 'opacity-100'}/>
                            <span>ثبت اطلاعات</span>
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default Profile;